import Validate from './Validate.js';

function initForm() {

    // Валидация и отправка формы
    App.H.find('.js-validate-form').each(function() {
        const $form = $(this);
        const $btn = $form.find('.js-submit');
        const $ajaxError = $form.find('.js-ajax-error');
        const $staticAjaxError = $form.find('.js-static-ajax-error');

        // Валидация
        new Validate(this);


        // Отправка
        $form.on('submit', function(e) {
            e.preventDefault();

            // Блокируем кнопку сабмита
            $btn.attr('disabled', true);

            // Отправляем форму
            $form.ajaxSubmit({
                url: $form.attr('action'),
                dataType: 'json',
                type: $form.attr('method'),
                cache: false,
                success: (response) => {

                    // Ошибка на сервере
                    if (!response.success) {
                        if (response.message) {
                            if ($staticAjaxError.length) {
                                $staticAjaxError.slideDown();
                            } else {
                                $ajaxError.html(response.message);
                            }

                            $ajaxError.html(response.message);
                        }

                        $btn.removeAttr('disabled');
                    } else {
                        // Успех!
                        if (response.message) {
                            $form.find('.js-ajax-answer').html(response.message);
                        }

                        resetForm($form);
                        $ajaxError.html('');
                        $staticAjaxError.fadeOut();
                        $form.removeClass('_error').addClass('_success');
                        $form.find('.js-upload').val('').change();
                    }
                },
                error: () => {
                    // Ошибка отправки
                    $ajaxError.html($ajaxError.data('server-error'));
                    $btn.removeAttr('disabled');
                }
            });
        });
    });



    // Открытие и закрытие формы
    {
        App.H.find('.js-form-ok').off('click').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.js-form').removeClass('_success _error');
        });
    }



    // Загрузка файла
    App.H.on('change', '.js-upload', function() {
        const $input = $(this);
        const $label = $input.siblings('.js-upload-label');
        const val = $input.val();
        let fileName;

        if (val.length) {
            fileName = val.split('\\').pop() || '';
            $label.text(fileName);
            $input.addClass('_active');
        } else {
            $label.text( $label.data('text') );
            $input.removeClass('_active');
        }
    });

    /*App.H.on('click', '.js-upload-clear', function() {
        $(this).siblings('.js-upload').val('').change();
    });*/


    // Антиспам
    (function() {
        // return;
        let seconds = 0;

        // Проверка phantomJS
        let isBot = function() {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true;  //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver

            return retval;
        };

        if (isBot()) {
            return false;
        }


        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        $('.js-validate-form').each(function () {
            let name = $(this).data('name');
            $(this).append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);
        });

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            seconds++;
            App.H.find('.js-input-seconds').val(seconds);
        }, 1000);
    })();



    // Фикс autocomplete="off" для IE и Edge
    if (App.ie || App.edge) {
        window.onbeforeunload = function() {
            $('form[autocomplete="off"]').each(function() {
                this.reset();
            });
        };
    }

    // Маска для даты
    $('.js-date-mask').inputmask();
}

initForm();


// Сброс формы
export function resetForm(_form) {
    _form[0].reset();
    _form.find('.js-submit').attr('disabled', true);
    // _form.find(':checkbox[data-required]').prop('checked', true);
    _form.find(':checkbox[data-required]').not(':checked').addClass('_notvalidated');
    _form.removeClass('_success _error');
    _form.find('[data-required]').not(':checkbox').addClass('_notvalidated');
    _form.find('[data-required-group]').addClass('_notvalidated');
    _form.find('._focused input').each(function() {
        if ( !$(this).val().length ) {
            $(this).closest('.js-input-wrap').removeClass('_focused');
        } else {
            $(this).removeClass('_notvalidated');
        }
    });

    _form.find('.js-upload-file-wrap').removeClass('_file-ok');
    _form.find('.js-upload-files-label').removeClass('_no-empty _error').html(_form.find('.js-upload-files-label').data('default'));
    _form.find('._error').removeClass('_error');
    _form.removeClass('_success');
}

// Удаляем файл из формы
App.H.on('click', '.js-remove-file', function(e) {
    let fileInputLabel = $(this).siblings('.js-upload-files-label');

    $(this).closest('.js-upload-file-wrap').removeClass('_file-ok')
        .find('.js-upload-file-input').val('');

    fileInputLabel.removeClass('_no-empty _error').html(fileInputLabel.data('default'));

    e.preventDefault();
});



App.H.on('focusout', '.js-upload-file-input', function() {
    $(this).parent().removeClass('_focused');
});



/* при выборе файлов запускаем проверку на размер и кол-во файлов */
App.H.on('change', '.js-upload-file-input', function(e) {
    let files = e.originalEvent.target.files;

    chooseFiles(files, $(this));
});


/* Закрытие формы и сброс данных */
App.H.on('click', '.js-ok-btn', function(e) {
    let $thisForm = $(this).closest('.js-validate-form');

    resetForm($thisForm);

    if ($thisForm.closest('.js-popup-wrap').hasClass('_open')) {
        $thisForm.closest('.js-popup-wrap').find('.js-close-popup-form').trigger('click');
    }

    e.preventDefault();
});

/* Проверяет не превышен ли лимит на файлы и их размер и выводит соответствующее соощение */
function chooseFiles (files, fileInput) {
    let files_size = 0;
    let fileInputLabel = fileInput.parent().siblings('.js-upload-files-label');
    let fileName = '';

    $.each(files, function(index, el) {
        files_size += el.size;
        fileName = el.name;
    });

    if (files.length === 0) {
        fileInputLabel.removeClass('_no-empty _error').html(fileInputLabel.data('default'));
    } else if((files_size / 1000000 > parseInt(fileInput.data('max-size'))) || (files.length > parseInt(fileInput.data('max-count')))) {
        let error_text = fileInput.data('error');

        error_text = error_text.replace('count', fileInput.data('max-count'));
        error_text = error_text.replace('size', fileInput.data('max-size'));
        fileInputLabel.addClass('_no-empty _error').html(error_text);
        fileInputLabel.closest('.js-upload-file-wrap').addClass('_file-error');
    } else {
        fileInputLabel.removeClass('_error').addClass('_no-empty').html(fileName);
        fileInputLabel.closest('.js-upload-file-wrap').addClass('_file-ok');
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/Form.js